import * as React from 'react'
import { ReactElement, useEffect, useMemo, useState } from 'react'
import ComposeOutlookItemDialogBody, { ComposeOutlookItemDialogBodyProps } from './ComposeOutlookItemDialogBody'
import useAxios from '../../../../hooks/useAxios'
import { getDriveItemDownloadUrl } from '../../../../helpers/documentHelper'
import { HammockDialogProps } from '../HammockDialog'
import { FolderDriveItem } from '../../../../components/Document/DocumentFlatTree'
import { outlookDisplayNewMessageForm } from '../../../../helpers/outlookHelper'

export type ComposeEmailDialogBodyProps = Pick<ComposeOutlookItemDialogBodyProps, 'file' | 'parties' | 'callback'> & {
    selectedDriveItems?: FolderDriveItem[]
}

type BodyProps = ComposeEmailDialogBodyProps & ComposeOutlookItemDialogBodyProps

export default function ComposeEmailDialogBody(props: HammockDialogProps<ComposeEmailDialogBodyProps>): ReactElement {
    const axios = useAxios()

    const dialogBodyProps = useMemo(() => props.dialogBodyProps?.() ?? ({} as ComposeEmailDialogBodyProps), [props])

    const [attachments, setAttachments] = useState<Promise<Office.MessageFormAttachment>[]>([])

    useEffect(() => {
        setAttachments(
            (dialogBodyProps.selectedDriveItems || []).map(item =>
                getDriveItemDownloadUrl(item.id, axios).then(downloadUrl => ({
                    type: 'file',
                    name: item.name,
                    url: downloadUrl,
                    isInline: false,
                })),
            ),
        )
    }, [dialogBodyProps?.selectedDriveItems])

    return (
        <ComposeOutlookItemDialogBody<BodyProps>
            {...(props as HammockDialogProps<BodyProps>)}
            dialogBodyProps={() =>
                ({
                    ...dialogBodyProps,
                    titleKey: 'action.create.email',
                    descriptionKey: 'action.create.email.description',
                    submitButtonTextKey: 'action.create.email',
                    onCompose: async (toRecipients: Office.EmailAddressDetails[], subject: string) => {
                        Promise.all(attachments).then(resolvedAttachments => {
                            outlookDisplayNewMessageForm(
                                {
                                    toRecipients,
                                    attachments: resolvedAttachments,
                                    subject,
                                },
                                (asyncResult?: Office.AsyncResult<void>) => {
                                    if (!asyncResult || asyncResult?.status === Office.AsyncResultStatus.Succeeded) {
                                        dialogBodyProps.callback?.()
                                        props.onDismiss()
                                    }
                                },
                            )
                        })
                    },
                }) as BodyProps
            }
        />
    )
}
